import { Voter } from "./containers";

export default Voter;
